import { createSelector } from 'reselect';
import { onboardingSelector } from '../reducers/onboarding';
import { sessionSelector } from '../reducers/session';

/**
 * Determine if every subsection of contact config is complete.
 */
const getContactsCompleted = createSelector(
  [
    onboardingSelector.getContactsCompleted,
    onboardingSelector.areImportantContactsSelected,
    onboardingSelector.areEscalationsSelected,
    onboardingSelector.areReportRecipientsSelected,
    onboardingSelector.areAccessControlsSelected,
  ],
  (...contactSections) => contactSections.every((completed) => completed),
);

/**
 * Calculate some numbers to reflect the current progress;
 * note: only visible section is taken into consideration.
 */
const getCompletionStatus = createSelector(
  [
    onboardingSelector.getSectionVisibility.contacts,
    getContactsCompleted,
    onboardingSelector.getSectionVisibility.sites,
    onboardingSelector.getSiteConfigCompleted,
    onboardingSelector.getSectionVisibility.endpoint,
    onboardingSelector.getEndpointConfigCompleted,
    onboardingSelector.getSectionVisibility.cloudSensors,
    onboardingSelector.getCloudSensorConfigCompleted,
    onboardingSelector.getSectionVisibility.internetExposure,
    onboardingSelector.getInternetExposureCompleted,
    sessionSelector.hasCompletedTKO,
  ],
  (
    contactSectionVisible,
    contactSectionCompleted,
    siteSectionVisible,
    siteSectionCompleted,
    endpointConfigVisible,
    endpointConfigCompleted,
    cloudSensorVisible,
    cloudSensorCompleted,
    internetExposureVisible,
    internetExposureCompleted,
    hasCompletedTKO,
  ) => {
    let total = 0,
      completed = 0;
    if (contactSectionVisible) {
      total++;
      if (contactSectionCompleted) {
        completed++;
      }
    }

    if (siteSectionVisible) {
      total++;
      if (siteSectionCompleted) {
        completed++;
      }
    }

    if (cloudSensorVisible) {
      total++;
      if (cloudSensorCompleted) {
        completed++;
      }
    }

    if (internetExposureVisible) {
      total++;
      if (internetExposureCompleted) {
        completed++;
      }
    }

    if (endpointConfigVisible && !hasCompletedTKO) {
      total++;
      if (endpointConfigCompleted) {
        completed++;
      }
    }

    return {
      totalSections: total,
      completedSections: completed,
      incompleteSections: total - completed,
      allCompleted: total === completed,
    };
  },
);

export const memoizedOnboardingCompletionSelectors = {
  getContactsCompleted,
  getCompletionStatus,
};
